import { render } from "./tree-menu.vue?vue&type=template&id=10fdb1d7&scoped=true"
import script from "./tree-menu.vue?vue&type=script&lang=js"
export * from "./tree-menu.vue?vue&type=script&lang=js"

import "./tree-menu.vue?vue&type=style&index=0&id=10fdb1d7&scoped=true&lang=css"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fdb1d7"]])

export default __exports__